import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import PayoutsHome from "./PayoutsHome";

export default function Campaigns() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <PayoutsHome />
      </Route>
    </Switch>
  );
}
